// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Router from "next/router";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as PathHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/PathHelpers.mjs";
import * as ModalContext$PorterinFeature from "../../../../contexts/modal-context/ModalContext.mjs";
import * as SpotRequirementCmp$PorterinFeature from "./SpotRequirementCmp.mjs";
import * as SpotRequirementModuleScss from "../styles/SpotRequirement.module.scss";
import * as SpotEstimateInputModuleScss from "../styles/SpotEstimateInput.module.scss";

var styles = SpotEstimateInputModuleScss;

var modalStyles = SpotRequirementModuleScss;

function SpotEstimateRequirementCmp(Props) {
  var label_error = Props.label_error;
  var requirement = Props.requirement;
  var form = Props.form;
  var requirement_content = Props.requirement_content;
  var children = Props.children;
  var icon = Props.icon;
  var is_filled = Props.is_filled;
  var match = React.useState(function () {
        return false;
      });
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowOptions = match$1[1];
  var router = Router.useRouter();
  var match$2 = ModalContext$PorterinFeature.useModalContext(undefined);
  var error = label_error.error;
  var label = label_error.label;
  var toggleModal = match$2.toggleModal;
  var fieldClickHandler = function (param) {
    var match = PathHelpers$PorterinUtils.getRoutePathList(router.pathname);
    if (match) {
      switch (match.hd) {
        case "" :
            if (!match.tl) {
              return Curry._1(setShowOptions, (function (param) {
                            return true;
                          }));
            }
            break;
        case "services" :
            if (!match.tl) {
              return Curry._1(setShowOptions, (function (param) {
                            return true;
                          }));
            }
            break;
        default:
          
      }
    }
    Curry._1(toggleModal, {
          TAG: /* SpotRequirement */6,
          _0: true,
          _1: form,
          _2: requirement,
          _3: requirement_content
        });
  };
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: styles.container,
                  onClick: fieldClickHandler
                }, React.createElement("div", {
                      className: Belt_Option.isSome(error) ? "" + styles["input-container"] + " " + styles["input-container-error"] + "" : (
                          match[0] ? "" + styles["input-container-focus"] + " " + styles["input-container"] + "" : styles["input-container"]
                        )
                    }, React.createElement("div", {
                          className: styles["field-wrapper"]
                        }, React.createElement("label", {
                              className: "" + styles["label-required"] + " \n            " + (
                                Belt_Option.isSome(error) ? styles.error : ""
                              ) + "\n            " + (
                                is_filled ? "" : styles.filled
                              ) + "\n            ",
                              htmlFor: label
                            }, label), children, React.createElement("div", {
                              className: styles["error-icon"]
                            }, React.createElement(NextImage$PorterinFeature.make, {
                                  src: icon.path,
                                  height: 18.0,
                                  width: 18.0,
                                  quality: 70.0,
                                  alt: icon.alt_text
                                })))), error !== undefined ? React.createElement("div", {
                        className: styles["error-container"]
                      }, error) : null), match$1[0] ? React.createElement("div", {
                    className: modalStyles["requirement-options-wrapper"],
                    onClick: (function ($$event) {
                        Curry._1(setShowOptions, (function (param) {
                                return false;
                              }));
                      })
                  }, React.createElement("div", {
                        className: modalStyles["bottom-sheet"]
                      }, React.createElement(SpotRequirementCmp$PorterinFeature.make, {
                            requirement: requirement,
                            show_modal: setShowOptions,
                            form: form,
                            requirement_content: requirement_content
                          }))) : null);
}

var make = SpotEstimateRequirementCmp;

export {
  styles ,
  modalStyles ,
  make ,
}
/* styles Not a pure module */
